import { Enums } from "@flightscope/baseball-stats";
import colors from "./helpers/colors";

export default {
  [Enums.BattedBallType.FlyBall.key]: colors.green.vidaLoca,
  [Enums.BattedBallType.LineDrive.key]: colors.red.thunderbird,
  [Enums.BattedBallType.GroundBall.key]: colors.yellow.dolly,
  [Enums.BattedBallType.PopUp.key]: colors.purple.lavender,
  [Enums.BattedBallType.Unidentified.key]: colors.grey.doveGray,
};
